import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { PopupService } from "src/app/shared/popup/popup.service";
import { HttpHandlerService } from "src/app/core/services/http-handler.service";
import { Config } from "src/app/core/config/api.config";
import { TranslationModuleEnum } from "../../utils/translation-modules.enum";

@Component({
  selector: "app-strategic-kpis-modal",
  templateUrl: "./strategic-kpis-modal.component.html",
  styleUrls: ["./strategic-kpis-modal.component.scss"],
})
export class StrategicKpisModalComponent
  implements OnInit, OnChanges, OnDestroy
{
  isGettingKPIs: boolean = false;
  @Input() modalId: string;
  @Input() title: string;
  @Input() openModal: boolean = false;
  @Output() openModalChange = new EventEmitter<boolean>();
  @Input() titleTranslationKey: string;
  @Input() titleTranslationModuleEnum: number;
  @Input() selectedGroupId: [] | number;
  @Input() selectedYear: number;
  translationModulesEnum = TranslationModuleEnum;
  @Input() selectedKPIs: [];
  @Input() typeOfComponent :string;
  @Input() selectedKPIsIds: number[];

  kpIs = [];
  private endSub$ = new Subject();

  @Output() onSelectKPIs = new EventEmitter<any[]>();
  @Output() onSelectKPIsIds = new EventEmitter<number[]>();
  @Output() onBack = new EventEmitter();

  constructor(
    private popupService: PopupService,
    private httpService: HttpHandlerService
  ) {}

  ngOnInit(): void {}

  oldSelectedKPIs: any = [];
  oldSelectedKPIsIds: any = [];

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

    if (changes.selectedKPIs && changes.selectedKPIs.currentValue) {
      this.selectedKPIsIds = this.selectedKPIs.map(kpi => kpi["id"]);
      if(this.typeOfComponent == 'dynamic'){
       this.oldSelectedKPIs = this.selectedKPIs;
      this.oldSelectedKPIsIds = this.selectedKPIsIds;  
      }
    }

    if (this.openModal) {
      this.onOpenKPIsModal();
    }

    if (
      (changes.selectedGroupId && changes.selectedGroupId?.firstChange) ||
      !changes.selectedGroupId?.firstChange ||
      changes.selectedGroupId?.currentValue === undefined ||
      (changes.selectedYear && changes.selectedYear?.firstChange) ||
      !changes.selectedYear?.firstChange
    ) {
      this.getKPIs();
    }
  }

  onOpenKPIsModal() {
    this.popupService.open(this.modalId);
  }

  onPopupClose() {
    this.openModal = false;
    this.openModalChange.emit(this.openModal);
    this.popupService.close();
    if(this.typeOfComponent == 'dynamic'){
      this.selectedKPIs = this.oldSelectedKPIs;
      this.selectedKPIsIds = this.oldSelectedKPIsIds;
    }


  }

  getKPIs() {
    this.isGettingKPIs = true;
    this.kpIs = [];
    const year = this.selectedYear
      ? this.selectedYear
      : new Date().getFullYear();
    let searchOject;
    let url;
    if (Array.isArray(this.selectedGroupId)) {
      url = Config.MangeScorecards.getYearKPIs;
      const groups: number[] = [];
      this.selectedGroupId.forEach((ele: any) => {
        groups.push(ele.id);
      });
      searchOject = {
        groups: groups,
        year: year,
      };
    } else {
      if (!this.selectedGroupId) {
        this.isGettingKPIs = false;
        return;
      }
      url = Config.MangeScorecards.getYearGoals;
      searchOject = {
        groupId: this.selectedGroupId,
        year: year,
      };
    }

    this.httpService
      .post(url, searchOject)
      .pipe(
        takeUntil(this.endSub$),
        finalize(() => {
          this.isGettingKPIs = false;
        })
      )
      .subscribe(res => {
        this.kpIs = res;
      });
  }

  getSelectedStrategicKPIs(kpis: any) {
    this.selectedKPIs = kpis;
  }

  getSelectedStrategicKPIsIds(kpisIds: any) {
    this.selectedKPIsIds = kpisIds;
  }

  onSave() {
    this.onSelectKPIs.emit(this.selectedKPIs);
    this.onSelectKPIsIds.emit(this.selectedKPIsIds);
        this.openModal = false;
    this.popupService.close();
  }

  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }
}
